interface PendoVisitor {
    id: string;
    userId: string;
    userName: string;
    isAdministrator: boolean;
}

interface PendoAccount {
    id: number | undefined;
    accountName: string;
    isCloud : boolean;
}

interface PendoInitializeOptions {
    visitor: PendoVisitor;
    account: PendoAccount;
}

interface Pendo {
    visitorId?: string;
    initialize: (options: PendoInitializeOptions) => void;
}

export function initializePendo(
    pendo: Pendo,
    userInfo: {
        isAdministrator: boolean;
        companyId: number | undefined;
        companyName: string;
        userId: string;
        userName: string;
    }
): void {
    let visitorId = "";
    let accountId = userInfo.companyId;
    const isCloud = !!userInfo.companyId;
    if (!userInfo.companyId) {
        accountId = toHash(userInfo.companyName);
        visitorId = accountId + "_" + userInfo.userName;
    } else {
        visitorId = accountId + "_" + userInfo.userId;
    }

    if (pendo && (!pendo.visitorId || pendo.visitorId !== visitorId)) {
        pendo.initialize({
            visitor: {
                id: visitorId,
                userId: userInfo.userId,
                userName: userInfo.userName,
                isAdministrator: userInfo.isAdministrator
            },
            account: {
                id: accountId,
                accountName: userInfo.companyName,
                isCloud : isCloud
            }
        });
    }
}

function toHash(string: string): number {

    let hash: number = 0;

    if (string.length == 0) return hash;

    for (let i = 0; i < string.length; i++) {
        let char: number = string.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash;
    }

    return hash;
}